/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/*
  This tabControl component was used to handle the different tab content and tabs from pages.
*/
// System defined variables
import React, { useState } from 'react'
import { Tabs, Tab } from '@mui/material'
// Custom defined variables
import './TabControl.css'
import utils from '../../../../utils/utils'
import favoriteContractActive from '../../../../assets/static/favorite_contract_active.svg'
import favoriteContractInactive from '../../../../assets/static/favorite_contract_inactive.svg'

function TabPanel(props) {
  const { children, value, index, className } = props
  return (
    <div
      className={`${className}`}
      role=""
      hidden={value !== index}
      id={`tabPanel_${index}`}
    >
      {children}
    </div>
  )
}
function TabControl({
  datasource,
  selectedTabIndex,
  onChangeHandler,
  className,
  dataTestId,
  scrollable = true,
  linkedCasesCount,
  hasFavouriteIcon,
  toggleFavouriteHandler,
  contractType,
}) {
  const [hoveredTabIndex, setHoveredTabIndex] = useState(null)
  const onChange = (event, newSelectedIndex) => {
    onChangeHandler(event, newSelectedIndex)
  }
  const generateTabTitleComponent = (item, index) => (
    <div
      className={`tabTitleButton ${
        index === selectedTabIndex ? 'contained' : 'text'
      }`}
    >
      {item?.tabTitle === utils?.linkedCases &&
      contractType !== utils?.contractTypes?.fpnName
        ? `${item?.tabTitle} (${linkedCasesCount})`
        : item?.tabTitle}
    </div>
  )

  const handleMouseEnter = (index) => {
    setHoveredTabIndex(index)
  }

  const handleMouseLeave = () => {
    setHoveredTabIndex(null)
  }

  const generateTabIcon = (item, index) => {
    const shouldShowFavouriteIcon =
      item?.isFavourite ||
      index === selectedTabIndex ||
      index === hoveredTabIndex
    return (
      <>
        {hasFavouriteIcon && (
          <>
            {shouldShowFavouriteIcon ? (
              <img
                id={`${
                  item?.isFavourite ? 'favouriteIcon' : 'non_favouriteIcon'
                }`}
                className="favouriteIcon"
                src={
                  item?.isFavourite
                    ? favoriteContractActive
                    : favoriteContractInactive
                }
                data-testid={`${
                  item?.isFavourite ? 'favouriteIcon' : 'non_favouriteIcon'
                }`}
                onClick={() =>
                  item?.shouldApiBlock === false &&
                  toggleFavouriteHandler(
                    item,
                    item?.isFavourite ? 'remove' : 'add'
                  )
                }
                alt="Favorite"
              />
            ) : (
              <div className="iconPlaceholder" />
            )}
          </>
        )}
      </>
    )
  }

  return (
    <div className="tabControl">
      <div className="tabHeader">
        <Tabs
          value={selectedTabIndex}
          onChange={onChange}
          className={`tabHeaderTabs ${className}`}
          variant={`${scrollable ? 'scrollable' : ''}`}
          scrollButtons="auto"
          data-testid={`${dataTestId || 'tabControl'}`}
        >
          {datasource?.map((item, index) => {
            return Object?.keys(item)?.length > 0 ? (
              <Tab
                disableTouchRipple
                className={`tabHeaderTab ${item?.className}`}
                value={index}
                key={index}
                icon={generateTabIcon(item, index)}
                iconPosition="end"
                label={generateTabTitleComponent(item, index)}
                disabled={item?.disabled || false}
                data-testid={item?.dataTestId}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              />
            ) : (
              <></>
            )
          })}
        </Tabs>
      </div>
      {datasource?.map((item, index) => {
        if (index === selectedTabIndex)
          return (
            <TabPanel
              value={selectedTabIndex}
              index={index}
              className={`tabContent ${item?.contentClassName}`}
              key={index}
            >
              {item?.tabContent}
            </TabPanel>
          )
      })}
    </div>
  )
}

export default TabControl
